import React, { useCallback } from 'react';
import styled from 'styled-components';

import NavigateBack from 'actions/current_location/navigate_back';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export default function MobileBackHeader() {
  const executeAction = useExecuteAction();
  const handleBack = useCallback(() => executeAction(NavigateBack), [executeAction]);

  return (
    <HeaderContainer data-aid="mobileBackHeader">
      <BackButton aria-label="Go back" data-aid="mobileBackButton" onClick={handleBack} type="button">
        <BackArrow>&#8592;</BackArrow>
      </BackButton>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
`;

const BackButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  width: 40px;

  &:active {
    opacity: 0.6;
  }
`;

const BackArrow = styled.span`
  color: ${p => p.theme.colors.gray800};
  font-size: 22px;
`;
